export default function Ticker() {
    const items = [
        "Pharmacokinetic modeling",
        "AI bloodwork analysis",
        "Multi-route PK curves",
        "Topical testosterone · Topi-CLICK®",
        "100+ compounds",
        "Optimized reference ranges",
        "Vermeulen · Mazer · Södergård · Zakharov",
        "Peptide reconstitution",
        "Rotation planner",
        "Inventory management",
        "Pathology partner integration",
    ];
    const doubled = [...items, ...items];
    return (
        <section
            data-testid="marquee-ticker"
            className="relative border-y border-white/5 bg-black py-4 overflow-hidden"
        >
            <div className="ticker-track flex gap-12 whitespace-nowrap text-sm">
                {doubled.map((t, i) => (
                    <span
                        key={i}
                        className="inline-flex items-center gap-3 text-white/50 font-mono uppercase tracking-widest text-[11px]"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-[#2ba6e0]" />
                        {t}
                    </span>
                ))}
            </div>
        </section>
    );
}
